// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"de108018","453":"5b68e48d","455":"7bfefb70","977":"30812a03"}[chunkId] + ".chunk.js";
};